export enum ViewType {
  Port = 'Port',
  Dam = 'Dam'
}
